export type Member = {
  id: string;
  systemId: string;
  name: string;
  isFronting: boolean;
  createdAt: Date;
  updatedAt: Date|null;
};

export type System = {
  id: string;
  userId: string;
  parentId: string|null;
  name: string;
  members: Member[];
  createdAt: Date;
  updatedAt: Date|null;
};

export type User = {
  id: string;
  username: string;
  email: string|null;
  defaultSystemId: string|null;
  createdAt: Date;
  updatedAt: Date|null;
};

export type LogEntry = {
  id: string;
  authorIds: string[];
  entry: string;
  createdAt: Date;
  updatedAt: Date|null;
};

export enum MessageType {
  User = 'user',
  Notice = 'notice',
  Error = 'error',
  Success = 'success'
}

export type Message = {
  id: string;
  authorIds: string[];
  type: MessageType;
  entry: string;
  createdAt: Date;
  updatedAt: Date|null;
};

export type LoginRequest = {
  username: string
  password: string
};

export type LoginResponse = {
  jwtToken: string
};

export type RegisterRequest = {
  username: string
  password: string
};

export type RegisterResponse = {
  jwtToken: string
};